<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol option="md" :size="12">
        <meta-section>
          <!-- <div class="text-right">
            <div class="d-flex flex-row gap-2">
              <ArgonButton outline>Kembali</ArgonButton>
            </div>
          </div> -->
        </meta-section>
      </GridCol>
      <GridCol>
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="searchKeyword()" type="text" class="form-control"
                      placeholder="Cari nama atau nip disini..." style="border-right: 1px solid #d2d6da!important;" />
                  </InputGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.periode_id"
                      :list="
                        list_periode.sort((a, b) => a.name.localeCompare(b.name))
                      "
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Periode"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.unit"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Unit Kerja"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.jabatan"
                      :list="jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Jabatan"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.status"
                      :list="status_list.map((item) => {
                        return {
                          id: item,
                          value: item.replaceAll('_', ' ')
                        }
                      })"
                      option-value="id"
                      option-text="value"
                      placeholder="Pilih Status"
                    />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <ListView>
            <template v-slot:thead>
              <tr>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  NIP
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Nama
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Posisi
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Unit Kerja
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Jabatan
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  Status
                </th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Aksi</th>
              </tr>
            </template>
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="7" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item.nip ?? "-" }}</td>
                <td>
                  <h6 class="mb-0">
                    <router-link :to="{
                      name: 'Laporan Kpi Pegawai Detail',
                      params: { employee_id: item?.employee_id, realization_id: item?.realization_id, periode_id: item?.periode_id },
                    }" data-original-title="Laporan Kpi Pegawai Detail">{{ item.name ?? "-" }}</router-link>
                  </h6>
                </td>
                <td>{{ item?.position ?? "-" }}</td>
                <td>{{ item?.unitkerja ? (item?.unitkerja?.length > 40 ? item?.unitkerja?.slice(0, 40) + "..." : item?.unitkerja) : "-" }}</td>
                <td>{{ item?.jabatan ? (item?.jabatan?.length > 40 ? item?.jabatan?.slice(0, 40) + "..." : item?.jabatan) : "-" }}</td>
                <td>
                  <argon-badge
                      v-if="item?.submission_status"
                      :color="status_color?.[item?.submission_status] || 'secondary'"
                      class="text-capitalize"
                    >
                      {{ item?.submission_status?.replaceAll('_', ' ') }}
                    </argon-badge>
                    <span v-else>-</span>
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{
                      name: 'Laporan Kpi Pegawai Detail',
                      params: { employee_id: item?.employee_id, realization_id: item?.realization_id, periode_id: item?.periode_id },
                    }" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Laporan Kpi Pegawai Detail">Detail</router-link>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
          </ListView>

          <!-- <div class="d-flex flex-row flex-wrap gap-2 justify-content-center align-items-center">
            <button type="button" @click="params.page = params.page - 1"
              class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-left" /></button>
            <p>{{ metaData?.current_page ?? "&infin;" }} / {{ metaData?.total_page ?? "&infin;" }}</p>
            <button type="button" @click="params.page = params.page + 1"
              class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-right" /></button>
          </div> -->

          <ArgonPagination
            :page="params.page"
            :total_page="metaData?.total_page"
            :current_page="metaData?.current_page"
            @changepage="getData"
            @changelimit="changeLimit"
          />
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent.vue";
import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import InputGroup from "@/components/InputGroup.vue";
import ListView from '@/components/ListView.vue';
import FormGroup from "@/components/FormGroup.vue";

import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from '@/repository/api/JabatanApi';
import LaporanPersonalApi from "@/repository/api/LaporanPersonalApi";

import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "tables",
  components: {
    CardComponent,
    ThreeDotsMenu,
    ArgonBadge,
    // ArgonButton,
    ArgonPagination,
    MetaSection,
    GridRow,
    GridCol,
    InputGroup,
    ListView,
    FormGroup,
    ModelListSelect,
  },
  data() {
    return {
      timer: null,
      data: [],
      metaData: {},
      employee: {},
      employee_role: '',
      params: {
        periode_id: "",
        jabatan: "",
        unit: "",
        keyword: "",
        status: "",
        limit: 10,
        page: 1,
      },
      list_periode: [],
      unitkerja: [],
      jabatan: [],
      status_list: [
        'submission',
        'accept_direct_supervisor',
        'reject_direct_supervisor',
        'accept_immediate_supervisor',
        'reject_immediate_supervisor',
      ],
      status_color: {
        submission: 'primary',
        accept_direct_supervisor: 'info',
        reject_direct_supervisor: 'danger',
        accept_immediate_supervisor: 'success',
        reject_immediate_supervisor: 'danger',
      }
    };
  },
  async mounted() {
    await this.getSessionUser();
    this.employee = this.$store.state?.sessionUser?.employee;
    this.employee_role = this.$store.state?.sessionUser?.groups?.[0]?.label;

    this.getPeriode();
    await this.getUnitKerja();
    await this.getData();
  },
  watch: {
    // 'params.page': {
    //   handler: async function (newVal, oldVal) {
    //     if (newVal < 1) {
    //       this.params.page = oldVal
    //     } else {
    //       // await this.getJabatan();
    //       await this.getData();
    //     }
    //   },
    //   deep: false,
    // },
    'params.periode_id': {
      handler: async function () {
        await this.getData();
      },
      deep: true,
    },
    'params.unit': {
      handler: async function () {
        this.params.jabatan = "";
        await this.getJabatan();
        await this.getData();
      },
      deep: true,
    },
    'params.jabatan': {
      handler: async function () {
        await this.getData();
      },
      deep: true,
    },
    'params.status': {
      handler: async function () {
        await this.getData();
      },
      deep: true,
    },
  },
  methods: {
    async getPeriode() {
      await KpiPeriodeApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.list_periode = response?.data;
          // this.params.periode_id = this.list_periode?.[0]?.id || '';
        })
        .catch(() => {
          this.list_periode = [];
        });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      // await UnitKerjaApi.get()
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
      })
        .then((response) => {
          this.unitkerja = response?.data;
        }).catch(() => {
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({
        unitkerja_id: this.params.unit,
        page: 'all',
      })
        .then((response) => {
          this.jabatan = response?.data;
        }).catch(() => {
          this.jabatan = [];
        })
      this.$store.state.loading = false;
    },

    async getData(page=1) {
      this.$store.state.loading = true;
      this.data = [];
      this.metaData = {};
      this.params.page = page;

      let params = this.params

      let role_exclude = ['']

      if (process.env.VUE_APP_EMPLOYEE_REPORT_ROLE_ACCESS) {
        const roles = process.env.VUE_APP_EMPLOYEE_REPORT_ROLE_ACCESS.split(',')
        role_exclude = [...role_exclude, ...roles]
      }

      if (!role_exclude.includes(this.employee_role)) {
        params.employee_id = this.employee.id
        params.leader_id = this.employee.id
        params.immediate_supervisor_id = this.employee.id
      }

      await LaporanPersonalApi.getList(params)
        .then((response) => {
          this.data = response?.data;
          this.metaData = {
            status: response?.status ?? null,
            message: response?.message ?? null,
            total_item: response?.total_item ?? null,
            per_page: response?.per_page ?? null,
            total_page: response?.total_page ?? null,
            current_page: response?.current_page ?? null,
          }
        }).catch((error) => {
          console.log(error)
          // if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          //   this.params.page = this.params.page - 1;
          // }
        });

      this.$store.state.loading = false;
    },
    async searchKeyword() {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        await this.getData();
      }, 650);
    },
    changeLimit(limit) {
      this.params.limit = limit;
      this.getData();
    },
  },
};
</script>
